<template>
    <div class="panel panel-default">
        <loading-spinner v-if="loading"></loading-spinner>

        <div v-else class="panel-body">
            <div v-if="magazineRecipients.data.length">
                <table class="table table-condensed table-striped">
                    <thead>
                    <tr>
                        <th class="col-xs-2 text-center">
                            <input type="checkbox" v-model="selectAll">
                        </th>

                        <th class="col-xs-6">
                            Name
                        </th>

                        <th class="col-xs-5">
                            Att.
                        </th>

                        <th class="col-xs-8">
                            Address
                        </th>

                        <th class="col-xs-1">
                            Count
                        </th>

                        <th class="col-xs-2"></th>
                    </tr>
                    </thead>

                    <tbody>
                    <tr v-for="magazineRecipient in magazineRecipients.data">
                        <td class="text-center">
                            <input type="checkbox" v-model="selected" :value="magazineRecipient">
                        </td>

                        <td class="ellipsis">
                            <span v-tooltip="getName(magazineRecipient)">
                                {{ getName(magazineRecipient) }}
                            </span>
                        </td>

                        <td class="ellipsis">
                            <span v-tooltip="getAttention(magazineRecipient)">
                                {{ getAttention(magazineRecipient) }}
                            </span>
                        </td>

                        <td class="ellipsis">
                            <span v-tooltip="getAddress(magazineRecipient)">
                                {{ getAddress(magazineRecipient) }}
                            </span>
                        </td>

                        <td>
                            {{ magazineRecipient.count }}
                        </td>

                        <td class="text-right">
                            <div class="btn-group list-actions">
                                <button type="button" class="btn btn-sm" @click="edit(magazineRecipient)">
                                    <i class="fa fa-search"></i>
                                </button>

                                <button type="button" class="btn btn-sm" @click="destroy(magazineRecipient)">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <div class="dropdown" v-if="selected.length">
                    <button
                            class="btn btn-black btn-sm dropdown-toggle"
                            type="button"
                            data-toggle="dropdown"
                    >
                        <i class="fa fa-cogs"></i> List Actions <span class="caret"></span>
                    </button>

                    <ul class="dropdown-menu">
                        <li>
                            <a href="#" @click.prevent="destroySelected">
                                <i class="fa fa-trash"></i> Delete
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div v-else class="text-center" style="margin: 40px">
                <i>
                    Noone receives the magazine from this subscription.
                </i>

                <br><br>

                <a href="#create-magazine-recipient-modal" class="btn btn-black btn-sm" data-toggle="modal">
                    <i class="fa fa-plus"></i> Create Magazine Recipient
                </a>
            </div>
        </div>

        <create-magazine-recipient-modal
                :subscription="subscription"
                @created="magazineRecipients.data.push($event)"
        ></create-magazine-recipient-modal>

        <edit-magazine-recipient-modal
                :magazineRecipient="editing"
                @updated="updated"
        ></edit-magazine-recipient-modal>
    </div>
</template>

<script>
    import http from '@/http'
    import modal from '@/modal'
    import notify from '@/notify'
    import CreateMagazineRecipientModal from '@/pages/Shared/Modals/CreateMagazineRecipient'
    import EditMagazineRecipientModal from '@/pages/Shared/Modals/EditMagazineRecipient'
    import Load from '@/mixins/Load'
    import LoadingSpinner from '@/components/Layout/LoadingSpinner'

    export default {
        components: {CreateMagazineRecipientModal, EditMagazineRecipientModal, LoadingSpinner},

        props: {subscription: {}},

        mixins: [Load],

        data() {
            return {
                magazineRecipients: null,
                selected: [],
                selectAll: false,
                editing: null
            }
        },

        mounted() {
            this.fetch()
        },

        watch: {
            selectAll(value) {
                this.selected = value ? this.magazineRecipients.data : []
            }
        },

        methods: {
            fetch() {
                this.load({magazineRecipients: '/api/v1/magazine-recipients?subscription=' + this.subscription.data.id})
            },

            destroySelected() {
                modal.confirm('Are you sure that you want to delete the magazine recipients?', () => {
                    Promise.all(this.selected.map(magazineRecipient => this.getDestroyPromise(magazineRecipient)))
                        .then(() => {
                            notify.success('The magazine recipients were deleted')

                            this.resetSelections()

                            this.fetch()
                        })
                })
            },

            destroy(magazineRecipient) {
                modal.confirm('Are you sure that you want to delete the magazine recipient?', () => {
                    this.getDestroyPromise(magazineRecipient)
                        .then(() => {
                            notify.success('The magazine recipient was deleted')

                            this.fetch()
                        })
                })
            },

            getDestroyPromise(magazineRecipient) {
                return http.delete('/api/v1/magazine-recipients/' + magazineRecipient.id)
            },

            resetSelections() {
                this.selected = []

                this.selectAll = false
            },

            edit(magazineRecipient) {
                this.editing = magazineRecipient

                $('#edit-magazine-recipient-modal').modal('show')
            },

            updated(magazineRecipient) {
                this.resetSelections()

                this.magazineRecipients.data.splice(
                    this.magazineRecipients.data.findIndex(existing => existing.id === magazineRecipient.id),
                    1,
                    magazineRecipient
                )
            },

            getName(magazineRecipient) {
                if (magazineRecipient.company) {
                    return magazineRecipient.company.name
                }

                return magazineRecipient.person.name
            },

            getAttention(magazineRecipient) {
                if (magazineRecipient.attention) {
                    return magazineRecipient.attention
                }

                if (magazineRecipient.company && magazineRecipient.person) {
                    return magazineRecipient.person.name
                }

                return ''
            },

            getAddress(magazineRecipient) {
                if (magazineRecipient.address) {
                    return magazineRecipient.address.street_address + ', ' + magazineRecipient.address.zip_code_and_city
                }

                if (magazineRecipient.company) {
                    return magazineRecipient.company.address.street_address + ', ' + magazineRecipient.company.address.zip_code_and_city
                }

                return magazineRecipient.person.address.street_address + ', ' + magazineRecipient.person.address.zip_code_and_city
            }
        }
    }
</script>
